/*
 * Franck Olivier — « Voir plus » : charge la page suivante et ajoute les produits
 * à la suite (sans recharger). Les cartes ajoutées (product-form / quick-add)
 * s'initialisent seules (custom elements). Repli : navigation classique si erreur.
 */
class FoLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.collection-fo__more-btn');
    if (this.button) this.button.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    event.preventDefault();
    const url = this.button.getAttribute('href');
    if (!url) return;
    this.button.classList.add('is-loading');
    try {
      const response = await fetch(url);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const grid = document.querySelector('[data-fo-grid]');
      const items = doc.querySelectorAll('[data-fo-grid] > .grid__item');
      items.forEach((item) => grid.appendChild(item));

      const nextButton = doc.querySelector('.collection-fo__more-btn');
      if (nextButton) {
        this.button.setAttribute('href', nextButton.getAttribute('href'));
      } else {
        this.remove();
      }
    } catch (e) {
      window.location.href = url;
    } finally {
      this.button.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('fo-load-more')) {
  customElements.define('fo-load-more', FoLoadMore);
}
